import createRoute from '@widesk-ui/tools/createRoute';
import FigureModel from '@models/website/FigureModel';

const route = createRoute.dashboardFromModel(
	FigureModel,
	'FigureDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
